/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const ContextMenuStyle = css`
  text-transform: capitalize;
`;
